import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  factorTemplatesLength: 0,
  factorTemplates: [],
  factorTemplatesAll: [],
  factorTemplate: {},
  factorTemplateError: "",
  formError: "",
  formCopyError: "",
};

export default function FactorTemplateReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_FACTOR_TEMPLATE:
      return { ...state, loading: action.payload };
    case actions.LOADING_FACTOR_TEMPLATE_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_FACTOR_TEMPLATE:
      return { ...state, saveLoading: action.payload };
    case actions.GET_FACTOR_TEMPLATE:
      return {
        ...state,
        factorTemplates: action.payload.factorTemplates,
        factorTemplatesAll: action.payload.factorTemplatesAll,
        factorTemplatesLength: action.payload.factorTemplatesLength,
      };
    case actions.GET_FACTOR_TEMPLATE_BY_ID:
      return {
        ...state, factorTemplate: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FORM_COPY_FAIL:
      return { ...state, formCopyError: action.payload };
    case actions.FACTOR_TEMPLATE_FAIL:
      return { ...state, factorTemplateError: action.payload };
    default:
      return state;
  }
}
